"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultParams = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var moment = require("moment");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var queryString = require("query-string");
var avatars_1 = require("components/Avatar/avatars");
var FileIcon = require("components/FileIcon");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var questionsActions = require("@caddigital/sok-reducers/lib/actions/bid/questions");
var questions_1 = require("@caddigital/sok-reducers/lib/reducers/bid/questions");
var translate_1 = require("utils/translate");
var search_1 = require("utils/search");
var Types = require("types");
var Tools_1 = require("./Tools");
var List_1 = require("./List");
var AddQuestionModal_1 = require("./AddQuestionModal");
var AnswerQuestionModal_1 = require("./AnswerQuestionModal");
var bidQuestionAnswerFile_1 = require("actions/bidQuestionAnswerFile");
var UploadModal_1 = require("./UploadModal");
require("./style.scss");
exports.defaultParams = {
    orderBy: 'question',
    order: 'asc'
};
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        questions: state.bid.questions,
        user: state.auth.current.user,
        questionsFolder: state.bid.current.questions,
        viewportSize: state.viewport.size,
        selectedLanguage: selectedLanguage
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    toggleUploadModal: function () { return dispatch(bidQuestionAnswerFile_1.default.toggleModalStatus()); },
    addQuestion: function (bid, question) {
        return dispatch(questionsActions.addQuestionRequest(bid, question));
    },
    getAnswerFile: function (folderId) {
        return dispatch(questionsActions.fetchFilesRequest(folderId, questions_1.sortByOptions, questions_1.searchOptions));
    },
    toggleAddQuestionModal: function () { return dispatch(questionsActions.toggleAddQuestion()); },
    answerQuestion: function (bid, questions) {
        return dispatch(questionsActions.answerQuestionRequest(bid, questions));
    },
    toggleAnswerQuestionModal: function (questions) {
        if (questions === void 0) { questions = []; }
        return dispatch(questionsActions.toggleAnswerQuestion(questions));
    },
    toggleExcludeStatus: function (bid, questions) {
        return dispatch(questionsActions.toggleExcludeStatusRequest(bid, questions));
    },
    deleteFile: function (files) {
        return dispatch(questionsActions.removeFileRequest(files));
    },
    clear: function () { return dispatch(questionsActions.clear()); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
function parseSearchString(location) {
    var params = queryString.parse(location.search);
    var keys = Object.keys(params).sort(function (a, b) { return a.localeCompare(b); });
    // Decode params
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        params[key] = decodeURIComponent(params[key]);
    }
    return params;
}
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('BidQuestionsAndAnswers'), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('queryParams', 'setQueryParams', {}), (0, recompose_1.withState)('isOpen', 'setIsOpen', false), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        var params = parseSearchString(this.props.location);
        var url = this.props.location.pathname +
            (0, search_1.getQueryParams)(__assign(__assign({}, exports.defaultParams), params));
        this.props.history.replace(url);
        this.props.setQueryParams(params);
        this.props.questionsFolder &&
            this.props.getAnswerFile(this.props.questionsFolder.id);
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.location.search !== prevProps.location.search) {
            var params = parseSearchString(this.props.location);
            var updatedParams = __assign(__assign({}, exports.defaultParams), params);
            this.props.setQueryParams(updatedParams);
        }
        if (this.props.questionsFolder &&
            this.props.questions.crud.status !== prevProps.questions.crud.status &&
            this.props.questions.crud.status === 'SAVED') {
            this.props.getAnswerFile(this.props.questionsFolder.id);
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
var clearSearchCross = function (props) {
    return (React.createElement("span", { className: 'search-box-right' }, props.queryParams.search !== undefined &&
        props.queryParams.search !== '' && (React.createElement(sok_ui_1.Icon, { onClick: function () {
            return props.history.push(props.location.pathname +
                (0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { search: undefined })));
        }, className: 'fa-times' }))));
};
var setFilter = function (props, filter) {
    return props.history.push(props.location.pathname + (0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { filter: filter })));
};
var AnswerFile = function (props) {
    if (props.status === 'FETCHING' || props.deleteStatus === 'SAVING') {
        return (React.createElement("div", { className: 'answer-file' },
            React.createElement("div", { className: 'loading' },
                React.createElement(sok_ui_1.LoadingSpinner, null))));
    }
    if (props.file.length > 0) {
        return (React.createElement("div", { className: 'answer-file' }, props.file.map(function (file) { return (React.createElement("div", { className: 'uploaded' },
            React.createElement("span", null, FileIcon.typeToIconAndTextMap(file.type).icon),
            React.createElement("div", { className: 'file-info' },
                React.createElement("a", { href: "".concat(__UPLOADSERVERURL__, "/files/").concat(file.uuid) }, file.name),
                React.createElement("div", null,
                    (0, translation_1.getLocalization)('bid/questionsAndAnswers/file/added'),
                    ' ',
                    file.meta && moment(file.meta.created_at).format('L'))),
            React.createElement("span", null,
                React.createElement(sok_ui_1.Icon, { className: 'fa-times', onClick: function () { return props.setIsOpen(true); } })))); })));
    }
    return (React.createElement("div", { className: 'answer-file' },
        React.createElement("div", { className: 'no-file' },
            React.createElement(sok_ui_1.Icon, { className: 'fa-file-alt' }),
            (0, translation_1.getLocalization)('bid/questionsAndAnswers/noFile'))));
};
exports.default = enhance(function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'bid-question-and-answer-view' },
            React.createElement("main", { className: 'content' },
                React.createElement(sok_ui_1.BreadCrumb, null,
                    React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bids") }, props.currentBriefcase.name),
                    React.createElement("span", null, props.currentBid.name),
                    React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bid/").concat(props.currentBid.id, "/participants/questionsAndAnswers") }, (0, translation_1.getLocalization)('bid/breadcrumb/questionsAndAnswers'))),
                React.createElement(sok_ui_1.RequestStatusBox, { status: props.questions.excludeStatus, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILED'] },
                    React.createElement("span", null, (0, translation_1.getLocalization)('bid/questionsAndAnswers/status/saving')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('bid/questionsAndAnswers/status/saved')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('bid/questionsAndAnswers/status/failed'))),
                React.createElement(sok_ui_1.RequestStatusBox, { status: props.questions.crud.status, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
                    React.createElement("span", null, (0, translation_1.getLocalization)('bid/questionsAndAnswers/delete/status/saving')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('bid/questionsAndAnswers/delete/status/saved')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('bid/questionsAndAnswers/delete/status/failed'))),
                (function () {
                    if (!props.currentBid.procerement.questionsAndAnswers) {
                        return (React.createElement("div", { className: 'not-enabled' },
                            React.createElement("span", null,
                                React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9'), width: 200, height: 200 })),
                            React.createElement("span", null, (0, translation_1.getLocalization)('global/dearSokoProUser')),
                            React.createElement("span", null, (0, translation_1.getLocalization)('bid/questionsAndAnswers/notEnabled1')),
                            React.createElement("span", null, (0, translation_1.getLocalization)('bid/questionsAndAnswers/notEnabled2'))));
                    }
                    return (React.createElement(React.Fragment, null,
                        React.createElement(sok_ui_1.BoxLayout, { direction: 'column' },
                            React.createElement(sok_ui_1.BoxLayout, { direction: props.viewportSize === 'DESKTOP' ? 'row' : 'column' },
                                React.createElement(sok_ui_1.Panel, { title: (0, translation_1.getLocalization)('bud/questions/schedule'), icon: React.createElement(sok_ui_1.Icon, { className: 'fa-clock', prefix: 'far' }) },
                                    React.createElement("div", { className: 'panel-schedule' },
                                        React.createElement("div", null,
                                            React.createElement("div", null,
                                                React.createElement("b", null,
                                                    (0, translation_1.getLocalization)('bid/questions/schedule/ends'),
                                                    ":")),
                                            React.createElement("div", null, moment(props.currentBid.procerement
                                                .questionsAndAnswersDeadline || 0).format('L LT'))),
                                        React.createElement("div", null,
                                            React.createElement("div", null,
                                                React.createElement("b", null,
                                                    (0, translation_1.getLocalization)('bid/questions/schedule/publish'),
                                                    ":")),
                                            React.createElement("div", null, moment(props.currentBid.procerement
                                                .questionsAndAnswersPublishedAt || 0).format('L LT'))))),
                                React.createElement(sok_ui_1.Panel, { title: (0, translation_1.getLocalization)('bid/questions/instructionFile/title'), icon: React.createElement(sok_ui_1.Icon, { className: 'fa-file-alt' }), className: 'panel-instructions' },
                                    React.createElement(AnswerFile, { status: props.questions.answerFileStatus, deleteStatus: props.questions.crud.status, file: props.questions.answerFile, setIsOpen: props.setIsOpen })))),
                        React.createElement("div", { className: 'search-container' },
                            React.createElement(sok_ui_1.TextInput, { value: props.queryParams.search || '', onChange: function (e) {
                                    return props.setQueryParams(__assign(__assign({}, props.queryParams), { search: e.target.value }));
                                }, placeholder: (0, translation_1.getLocalization)('bid/questionsAndAnswers/search/placeholder'), onBlur: function () {
                                    return props.history.push(props.location.pathname +
                                        (0, search_1.getQueryParams)(props.queryParams));
                                }, icon: React.createElement(sok_ui_1.Icon, { key: 'icon', className: 'fa-search' }), iconRight: clearSearchCross(props) })),
                        React.createElement("div", { className: 'filter-container' },
                            React.createElement(sok_ui_1.Dropdown2, { className: 'filter-list-dropdown' },
                                React.createElement(sok_ui_1.Button, { block: true, text: (0, translation_1.getLocalization)('global/filters'), color: 'dark-gray', border: 'yellow', icon: React.createElement(sok_ui_1.Icon, { key: 'icon', className: classNames('fa-columns') }), iconRight: React.createElement(sok_ui_1.Icon, { key: 'right-icon', className: 'fa-chevron-down' }) }),
                                React.createElement(sok_ui_1.Dropdown2Menu, null,
                                    React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () { return setFilter(props, undefined); } },
                                        React.createElement("span", null,
                                            React.createElement(sok_ui_1.Input, { className: 'filter', type: 'radio', name: 'selected', label: (0, translation_1.getLocalization)('bid/questions/filter/noFilters'), value: props.queryParams.filter === undefined }))),
                                    React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () { return setFilter(props, 'answered'); } },
                                        React.createElement("span", null,
                                            React.createElement(sok_ui_1.Input, { className: 'filter', type: 'radio', name: 'selected', label: (0, translation_1.getLocalization)('bid/questions/filter/answered'), value: props.queryParams.filter === 'answered' }))),
                                    React.createElement(sok_ui_1.Dropdown2MenuItem, { onClick: function () { return setFilter(props, 'unanswered'); } },
                                        React.createElement("span", null,
                                            React.createElement(sok_ui_1.Input, { className: 'filter', type: 'radio', name: 'selected', label: (0, translation_1.getLocalization)('bid/questions/filter/unanswered'), value: props.queryParams.filter === 'unanswered' }))))),
                            React.createElement("div", { className: 'filter-list-dropdown' },
                                React.createElement(sok_ui_1.Button, { color: 'blue', text: (0, translation_1.getLocalization)('global/clearFilters'), onClick: function () {
                                        return props.history.push(props.location.pathname +
                                            (0, search_1.getQueryParams)(exports.defaultParams));
                                    } }))),
                        React.createElement(List_1.QuestionList, { currentBid: props.currentBid, queryParams: props.queryParams, pathname: props.location.pathname, updateUrl: props.history.push, mode: 'sokopro' }),
                        React.createElement(AddQuestionModal_1.AddQuestionModal, { status: props.questions.addQuestionStatus, errors: props.questions.createErrors, isOpen: props.questions.addQuestionModal, onClose: props.toggleAddQuestionModal, onSave: function (question) {
                                return props.addQuestion(props.currentBid, question);
                            } }),
                        React.createElement(AnswerQuestionModal_1.AnswerQuestionModal, { status: props.questions.answerQuestionsStatus, errors: props.questions.answerErrors, isOpen: props.questions.answerQuestionsModal, questions: props.questions.answerQuestions, onClose: props.toggleAnswerQuestionModal, onSave: function (questions) {
                                return props.answerQuestion(props.currentBid, questions);
                            } })));
                })(),
                React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.isOpen, close: function () { return props.setIsOpen(false); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                        React.createElement(ConfirmDialog_1.Exclamation, null),
                        React.createElement("div", null,
                            React.createElement("div", { className: 'title please-confirm-text' },
                                React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                            React.createElement("div", { className: 'text' },
                                React.createElement("p", null, (0, translation_1.getLocalization)('bid/questionsAndAnswers/file/delete/areYouSure'))))), footer: React.createElement(React.Fragment, null,
                        React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                                if (props.questions.answerFile.length > 0) {
                                    props.deleteFile(props.questions.answerFile);
                                }
                                props.setIsOpen(false);
                            } }),
                        React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setIsOpen(false); } })) }),
                React.createElement(UploadModal_1.UploadModal, null))),
        React.createElement(Tools_1.Tools, { currentBid: props.currentBid, toggleUploadModal: props.toggleUploadModal, toggleAnswerQuestionModal: props.toggleAnswerQuestionModal, toggleAddQuestionModal: props.toggleAddQuestionModal, toggleExcludeStatus: function (questions) {
                return props.toggleExcludeStatus(props.currentBid, questions);
            }, selected: props.questions.selected })));
});
